import { Skeleton } from '@/components/ui/skeleton'

const SkeletonCard = (): JSX.Element => {
  return (
    <div className="flex flex-row items-center w-full gap-4 mb-2 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700">
      <div className="h-[88px] w-[156px] min-w-[156px] flex cursor-pointer m-2 rounded-md relative bg-[50%_50%] overflow-hidden">
        <span className="absolute top-0 bottom-0 left-0 right-0 w-full bg-gray-300 bg-no-repeat bg-cover">
          <Skeleton className="h-[88px] w-[156px] min-w-[156px]" />
        </span>
      </div>
      <div className="flex flex-col self-stretch justify-between flex-1 gap-2 py-3 pr-4">
        <Skeleton className="w-full h-[20px] rounded-full" />
        <Skeleton className="w-full h-[20px] rounded-full" />
        <Skeleton className="w-full h-[20px] rounded-full" />
      </div>
    </div>
  )
}
export default SkeletonCard
